<template>
	<div>
		<div class="block">
			<el-date-picker v-model="timeRange" type="datetimerange" start-placeholder="开始日期" end-placeholder="结束日期"
			:default-time="['00:00:00']">
			</el-date-picker>
			<el-button :loading="loading" @click='getOrderInfo'>查询</el-button>
		</div>
		<el-table :data="orderInfo" border style="width: 100%" v-loading="loading">
			<el-table-column prop="order_id" label="订单号" width="180">
			</el-table-column>
			<el-table-column prop="user_phone" label="用户电话" width="180">
			</el-table-column>
			<el-table-column prop="order_type" label="订单类型">
				<template slot-scope="scope">
					{{scope.row.order_type=='single_ele'?'电子照':'正装照'}}
				</template>
			</el-table-column>
			<el-table-column prop="spec_name" label="规格" width="180">
			</el-table-column>
			<el-table-column prop="final_pic_url" label="图片">
				<template slot-scope="scope">
					<a :href="scope.row.final_pic_url" target="__blank" class="link">图片</a>
				</template>
			</el-table-column>
			<el-table-column prop="fee" label="付款">
				<template slot-scope="scope">
					{{_convertCenttoYuan(scope.row.fee)}}
				</template>
			</el-table-column>
			<el-table-column prop="payment_time" label="下单时间">
			</el-table-column>
			<el-table-column prop="pay_type" label="支付方式">
				<template slot-scope="scope">
					{{scope.row.pay_type=='1'?'支付宝':'微信'}}
				</template>
			</el-table-column>
		</el-table>
	</div>
</template>

<script>
import {
	convertCenttoYuan
} from '../utils/utils.js'
import {
	mapState
} from "vuex";
import {
	getOrders
} from "../api/index.js"
export default {
	data() {
		return {
			orderInfo:[],
			loading:false,
			timeRange:[]
		}
	},
	computed:{
		...mapState([
			"app_info"
		]),
	},
	created() {
		this.timeRange[0] =new Date(new Date() - 1000 * 60 * 60 * 24);
		this.timeRange[1] =new Date();
	},
	methods:{
		getOrderInfo:function(){
			let params={
				webapp_key:this.app_info.webapp_key,
				start_time:this.timeRange[0],
				end_time:this.timeRange[1]
			}
			getOrders(params).then(res=>{
				if(res.data.code==200){
					this.orderInfo = res.data.order_list
				}
			})
		},
		_convertCenttoYuan:function(e){
			return convertCenttoYuan(e)
		}
	}
}
</script>

<style scoped="scoped">
</style>
